import { useMemo, useState } from 'react';

import {
  TopBannersHeightContext,
  TopBannersHeightContextValue,
} from './context';

export interface TopBannersHeightProviderProps {
  children: React.ReactNode;
}

export const TopBannersHeightProvider = ({
  children,
}: TopBannersHeightProviderProps) => {
  const [topBannersHeight, setTopBannersHeight] = useState(0);

  const value = useMemo(
    (): TopBannersHeightContextValue => ({
      topBannersHeight,
      setTopBannersHeight,
    }),
    [topBannersHeight],
  );

  return (
    <TopBannersHeightContext.Provider value={value}>
      {children}
    </TopBannersHeightContext.Provider>
  );
};
